module.exports = __webpack_public_path__ + "SCTProfessional/static/dist/img/logo_sct_piccolo.c277bb20.png";